import ControlsBar, { type ControlsBarProps } from './controls-bar'
import ControlsBarSpace from './controls-bar-space'


export default ControlsBar
export type { ControlsBarProps }
export { ControlsBarSpace }
